import { MediaDeviceInfoLite, MediaDevicesState } from "./types";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateMediaDevices = createAsyncThunk(
  "mediaDevices/updateMediaDevices",
  async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const result = {
        videoInputs: devices
          .filter((d) => d.kind === "videoinput" && d.deviceId !== "default")
          .map(({ deviceId, groupId, kind, label }) => {
            return { deviceId, groupId, kind, label };
          }),
        audioInputs: devices
          .filter(
            (d) =>
              d.kind === "audioinput" &&
              d.deviceId !== "default" &&
              d.deviceId !== "communications"
          )
          .map(({ deviceId, groupId, kind, label }) => {
            return { deviceId, groupId, kind, label };
          }),
        audioOutputs: devices
          .filter(
            (d) =>
              d.kind === "audiooutput" &&
              d.deviceId !== "default" &&
              d.deviceId !== "communications"
          )
          .map(({ deviceId, groupId, kind, label }) => {
            return { deviceId, groupId, kind, label };
          }),
      } as MediaDevicesState;

      const defaultDevices = devices
        .filter((d) => d.deviceId === "default")

      Object.entries(result).forEach(
        ([k, inputs]: [string, MediaDeviceInfoLite[]]) => {
          if (k === "videoInputs") {
            return;
          }

          inputs.forEach((input) => {
            input.isDefault = defaultDevices.some(d => d.groupId === input.groupId && d.kind === input.kind);
            return input;
          });
        }
      );
      return result;
    } catch (e) {
      throw e;
    }
  }
);
